export default function makeAuthRedirect({ authStore }) {
  return function authRedirect() {
    authStore.login()
  }
}
